module.exports = __webpack_public_path__ + "img/4_152.ff2b790f.png";